import { MicrositeConfigType, Qual } from 'types';
import { promoIdToMicrosite } from './promoIdToMicrosite';
import { AdAction } from './AdAction';
import { AdActionSpectrumPartner } from './AdActionSpectrumPartner';
import { AdActionATTPartner } from './AdActionATTPartner';
import { AppFolio } from './AppFolio';
import { ATTSpecial } from './ATTSpecial';
import { ApartmentList } from './ApartmentList';
import { BrightspeedSpecial } from './BrightspeedSpecial';
import { BuyEarthlink } from './BuyEarthlink';
import { Centerfield } from './Centerfield';
import { CenturyLinkSpecial } from './CenturyLinkSpecial';
import { CincinnatiBellSpecial } from './CincinnatiBellSpecial';
import { CoxCableSpecial } from './CoxCableSpecial';
import { CoxCableSpecialShop } from './CoxCableSpecialShop';
import { CoxCableSpecialGeneric } from './CoxCableSpecialGeneric';
import { CoxCableSpecialGenericShop } from './CoxCableSpecialGenericShop';
import { CoxAuthorizedOffers } from './CoxAuthorizedOffers';
import { CordlessATTPartner } from './CordlessATTPartner';
import { CordlessCoxPartner } from './CordlessCoxPartner';
import { CordlessXfinityPartner } from './CordlessXfinityPartner';
import { Demo } from './Demo';
import { DirecTVSpecials } from './DirecTVSpecials';
import { DishIFramed } from './DishIFramed';
import { MyDishIFramed } from './MyDishIFramed';
import { FrontierAuthorizedOffers } from './FrontierAuthorizedOffers';
import { KineticSpecial } from './KineticSpecial';
import { LLMSpectrumPartner } from './LLMSpectrumPartner';
import { LLMXfinityPartner } from './LLMXfinityPartner';
import { OptimumOffers } from './OptimumOffers';
import { PitchItIFramed } from './PitchItIFramed';
import { QuantumFiber } from './QuantumFiber';
import { RatePartner } from './RatePartner';
import { RealPageEmbed } from './RealPageEmbed';
import { SatCoXfinity } from './SatCoXfinity';
import { ShopLikeSamIFramed } from './ShopLikeSamIFramed';
import { SpectrumBravePartner } from './SpectrumBravePartner';
import { SpectrumSpecial } from './SpectrumSpecial';
import { StarryIFramed } from './StarryIFramed';
import { TDSAuthorizedOffers } from './TDSAuthorizedOffers';
import { Turbotenant } from './Turbotenant';
import { UpdaterInternet } from './UpdaterInternet';
import { VerizonDeals } from './VerizonDeals';
import { WOWWaySpecial } from './WOWWaySpecial';
import { XfinityBravePartner } from './XfinityBravePartner';
import { XfinitySpecial } from './XfinitySpecial';
import { XfinitySpecialZip } from './XfinitySpecialZip';
import { YardiEmbed } from './YardiEmbed';
import { YardiIFramed } from './YardiIFramed';

const list = [
  AdAction,
  AdActionSpectrumPartner,
  AdActionATTPartner,
  AppFolio,
  ApartmentList,
  ATTSpecial,
  BrightspeedSpecial,
  BuyEarthlink,
  Centerfield,
  CenturyLinkSpecial,
  CincinnatiBellSpecial,
  CoxCableSpecial,
  CoxCableSpecialShop,
  CoxCableSpecialGeneric,
  CoxCableSpecialGenericShop,
  CoxAuthorizedOffers,
  CordlessATTPartner,
  CordlessCoxPartner,
  CordlessXfinityPartner,
  DirecTVSpecials,
  DishIFramed,
  MyDishIFramed,
  FrontierAuthorizedOffers,
  KineticSpecial,
  LLMSpectrumPartner,
  LLMXfinityPartner,
  OptimumOffers,
  PitchItIFramed,
  QuantumFiber,
  RatePartner,
  RealPageEmbed,
  SatCoXfinity,
  ShopLikeSamIFramed,
  SpectrumBravePartner,
  SpectrumSpecial,
  StarryIFramed,
  TDSAuthorizedOffers,
  Turbotenant,
  UpdaterInternet,
  VerizonDeals,
  WOWWaySpecial,
  XfinityBravePartner,
  XfinitySpecial,
  XfinitySpecialZip,
  YardiEmbed,
  YardiIFramed,
  Demo,
];

export { list as MicrositeList };

export * from './AdAction';
export * from './AdActionSpectrumPartner';
export * from './AdActionATTPartner';
export * from './AppFolio';
export * from './ATTSpecial';
export * from './ApartmentList';
export * from './BrightspeedSpecial';
export * from './BuyEarthlink';
export * from './Centerfield';
export * from './CenturyLinkSpecial';
export * from './CincinnatiBellSpecial';
export * from './CoxAuthorizedOffers';
export * from './CoxCableSpecial';
export * from './CoxCableSpecialShop';
export * from './CoxCableSpecialGeneric';
export * from './CoxCableSpecialGenericShop';
export * from './CordlessATTPartner';
export * from './CordlessCoxPartner';
export * from './CordlessXfinityPartner';
export * from './Demo';
export * from './DirecTVSpecials';
export * from './DishIFramed';
export * from './FrontierAuthorizedOffers';
export * from './KineticSpecial';
export * from './LLMSpectrumPartner';
export * from './LLMXfinityPartner';
export * from './OptimumOffers';
export * from './PitchItIFramed';
export * from './QuantumFiber';
export * from './RatePartner';
export * from './RealPageEmbed';
export * from './SatCoXfinity';
export * from './ShopLikeSamIFramed';
export * from './SpectrumBravePartner';
export * from './SpectrumSpecial';
export * from './StarryIFramed';
export * from './TDSAuthorizedOffers';
export * from './Turbotenant';
export * from './UpdaterInternet';
export * from './VerizonDeals';
export * from './WOWWaySpecial';
export * from './XfinityBravePartner';
export * from './XfinitySpecial';
export * from './XfinitySpecialZip';
export * from './YardiEmbed';
export * from './YardiIFramed';

export function getMicrositeConfigFromCode(
  code: string
): MicrositeConfigType | undefined {
  return list.find((config) => {
    return config.micrositeCode === code;
  });
}

/**
 * Resolve a microsite config from a `promoId` via the `promoIdToMicrosite`
 * mapping. Returns `undefined` when the promoId is missing, unmapped, or maps
 * to a code that no longer resolves to a registered config.
 */
export function getMicrositeConfigFromPromoId(
  promoId: string | undefined
): MicrositeConfigType | undefined {
  if (!promoId) {
    return undefined;
  }
  const code = promoIdToMicrosite[promoId];
  return code ? getMicrositeConfigFromCode(code) : undefined;
}

export type MicrositeConfigSource = 'promoId' | 'microsite' | 'provider';

export interface MicrositeResolution {
  config?: MicrositeConfigType;
  /** The qual value used to resolve the config (promoId, microsite, or provider). */
  key?: string;
  source?: MicrositeConfigSource;
}

/**
 * Determine which microsite config to load from the qual, applying the
 * cascading precedence: promoId (when mapped) → microsite → provider.
 *
 * promoId takes priority to align with the upcoming config tool, which keys off
 * promoId rather than microsite code. An unmapped promoId falls through to the
 * legacy microsite/provider keys so existing quals are unaffected.
 */
export function resolveMicrositeConfig(
  qual: Pick<Qual, 'promoId' | 'microsite' | 'provider'>
): MicrositeResolution {
  const { promoId, microsite, provider } = qual;

  // UpdaterCrossSell redirects preserve the original promoId (needed for s12y)
  // but set microsite='Updater' to signal the config to load. Check this before
  // promoId so the cross-sell destination wins over the originating partner.
  if (microsite === 'Updater') {
    return {
      config: getMicrositeConfigFromCode(microsite),
      key: microsite,
      source: 'microsite',
    };
  }

  const promoIdConfig = getMicrositeConfigFromPromoId(promoId);
  if (promoIdConfig) {
    return { config: promoIdConfig, key: promoId, source: 'promoId' };
  }

  if (microsite) {
    return {
      config: getMicrositeConfigFromCode(microsite),
      key: microsite,
      source: 'microsite',
    };
  }

  if (provider) {
    return {
      config: getMicrositeConfigFromCode(provider),
      key: provider,
      source: 'provider',
    };
  }

  return {};
}
